/* La marca · v5 (Nira, 12-oct-2026). Un solo bucle de scroll, sin librerías. Tema Shopify: copia de web-trabajo con guarda de una sola ejecución. */
(function(){
  var d = document, w = window;
  /* en el tema cada sección mg-marca-*.liquid carga este archivo: solo corre una vez */
  if (w.__mkMarca) return;
  var root = d.querySelector('.mk'); if (!root) return;
  w.__mkMarca = 1;
  var RM = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOB = function(){ return w.innerWidth <= 760; };
  function cl(v, a, b){ return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); }
  function ez(t){ return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function $$(s, r){ return [].slice.call((r || d).querySelectorAll(s)); }
  function seg(s, a, len){ return cl((s - a) / len); }
  function split(el){
    var t = el.textContent, out = []; el.textContent = '';
    for (var i = 0; i < t.length; i++){
      var s = d.createElement('span'), c = t.charAt(i);
      s.className = 'ch' + (c === '.' ? ' mk-dot' : '');
      s.textContent = c === ' ' ? ' ' : c; el.appendChild(s); out.push(s);
    }
    return out;
  }
  function textW(e){ var r = d.createRange(); r.selectNodeContents(e); return r.getBoundingClientRect().width; }
  /* El ancho de Archivo no crece en proporción con el cuerpo: se mide en varias pasadas */
  function fitSize(els, width, cap){
    var f = 100;
    for (var k = 0; k < 4; k++){
      var max = 0;
      els.forEach(function(e){ e.style.fontSize = f + 'px'; max = Math.max(max, textW(e)); });
      if (!max) break; f = f * width / max;
    }
    els.forEach(function(e){ e.style.fontSize = ''; });
    return Math.min(cap || 9999, f);
  }

  /* ---------- 1 · Portada (MERCH tachado → MARCA) + 2 · Momentos ---------- */
  var A = d.querySelector('.jx-a'), H = null, MO = null;
  if (A){
    var hero = A.querySelector('.jx-hero');
    H = {
      a: split(hero.querySelector('.mk-w--a')), b: split(hero.querySelector('.mk-w--b')),
      la: hero.querySelector('.mk-hero__l1 .a'), lb: hero.querySelector('.mk-hero__l1 .b'),
      wb: hero.querySelector('.mk-w--b'), st: hero.querySelector('.mk-strike'), type: hero.querySelector('.mk-hero__type'),
      fit: function(){
        var fs = fitSize([hero.querySelector('.mk-w--a'), this.wb], this.type.clientWidth * .985, w.innerHeight * .4);
        hero.style.setProperty('--fs', fs.toFixed(1) + 'px');
        this.st.style.setProperty('--sl', textW(hero.querySelector('.mk-w--a')) + 'px');
      },
      up: function(p){
        hero.style.setProperty('--p', p.toFixed(4));
        this.st.style.setProperty('--s', ez(cl((p - .06) / .26)).toFixed(4));
        var o = cl((p - .34) / .18), n = cl((p - .44) / .22), f = ez(cl((p - .68) / .16));
        this.a.forEach(function(c, i){ c.style.transform = 'translateY(' + (ez(cl(o * 1.7 - i * .13)) * 112).toFixed(2) + '%)'; });
        this.st.style.opacity = (1 - ez(cl(o * 1.4))).toFixed(3);
        this.st.style.marginTop = (ez(cl(o * 1.4)) * .5).toFixed(3) + 'em';
        this.b.forEach(function(c, i){ c.style.transform = 'translateY(' + ((ez(cl(n * 1.7 - i * .13)) - 1) * 112).toFixed(2) + '%)'; });
        this.wb.style.setProperty('--f', f.toFixed(3));
        this.la.style.transform = 'translateY(' + (-ez(cl((p - .34) / .12)) * 105).toFixed(2) + '%)';
        this.lb.style.transform = 'translateY(' + ((1 - ez(cl((p - .44) / .14))) * 105).toFixed(2) + '%)';
      }
    };
    var mom = A.querySelector('.jx-mom'), sl = $$('.mx-sl', mom), tx = $$('.mx-tx', mom), dots = A.querySelector('.jx-dots');
    var num = mom.querySelector('.mx-n b'), nxt = mom.querySelector('.mx-next'), bar = mom.querySelector('.mx-bar');
    var N = sl.length, cur = -1;
    MO = { L: {}, R: {},
      fit: function(){
        var vw = w.innerWidth, vh = w.innerHeight, mob = MOB();
        var cw = mob ? vw * .36 : Math.min(vw * .15, vh * .26), ch = cw * 1.33;
        if (mob){ cw = vw * .26; ch = cw * 1.33; }
        this.R = { l: vw - (mob ? vw * .06 : vw * .04) - cw, t: mob ? vh * .16 : vh - vh * .12 - ch, w: cw, h: ch };
        nxt.style.setProperty('--nl', this.R.l + 'px'); nxt.style.setProperty('--nt', this.R.t + 'px');
        /* cada título cabe a la izquierda de la tarjeta de la siguiente foto */
        var pad = parseFloat(getComputedStyle(mom.querySelector('.mx-txs')).left) || 40;
        var maxW = mob ? vw - pad * 2 : this.R.l - pad - vw * .04;
        $$('.mx-t', mom).forEach(function(h){
          h.style.fontSize = '';
          var lines = $$('.ln > span', h), cs = parseFloat(getComputedStyle(h).fontSize), wmax = 0;
          lines.forEach(function(l){ wmax = Math.max(wmax, textW(l)); });
          if (wmax > maxW) h.style.fontSize = Math.floor(cs * maxW / wmax) + 'px';
        });
        this.L = { hero: vh * 1.4, wipe: vh * .8, mom: vh * (N - 1) * 1.05 + vh * .5, dots: vh * .7 };
        A.style.height = (vh + this.L.hero + this.L.wipe + this.L.mom + this.L.dots) + 'px';
      },
      up: function(s){
        var L = this.L, R = this.R, vw = w.innerWidth, vh = w.innerHeight;
        H.up(seg(s, 0, L.hero));
        mom.style.setProperty('--w', ez(seg(s, L.hero, L.wipe)).toFixed(4));
        var t = seg(s, L.hero + L.wipe * .7, L.mom), f = t * (N - 1) * 1.08;
        var a = 0, e = [];
        for (var i = 1; i < N; i++){ e[i] = ez(cl((f - (i - 1) - .2) / .62)); if (e[i] >= .5) a = i; }
        sl.forEach(function(el, i){
          if (i === 0){ el.style.visibility = (a >= 1 && e[1] >= .999) ? 'hidden' : 'visible'; return; }
          if (i > a + 1 || (i < a && e[a] >= .999)){ el.style.visibility = 'hidden'; return; }
          var k = 1 - e[i];
          el.style.visibility = 'visible';
          el.style.left = (R.l * k).toFixed(1) + 'px';
          el.style.top = (R.t * k).toFixed(1) + 'px';
          el.style.width = (vw - (vw - R.w) * k).toFixed(1) + 'px';
          el.style.height = (vh - (vh - R.h) * k).toFixed(1) + 'px';
          el.classList.toggle('is-card', k > .5);
        });
        if (a !== cur){ cur = a;
          tx.forEach(function(el, i){ el.classList.toggle('on', i === a); el.classList.toggle('out', i < a); });
          num.textContent = (a + 1 < 10 ? '0' : '') + (a + 1);
        }
        nxt.style.setProperty('--no', (a + 1 < N && (e[a + 1] || 0) < .04) ? 1 : 0);
        bar.style.setProperty('--pp', t.toFixed(4));
        dots.style.setProperty('--d', (ez(seg(s, L.hero + L.wipe + L.mom, L.dots)) * 16.5).toFixed(2));
      } };
  }

  /* ---------- 3 · La cita: la galería se mueve según su profundidad (--z) ---------- */
  var Q = d.querySelector('.jx-q'), QQ = null;
  if (Q){
    var gal = $$('.jx-gal figure', Q);
    QQ = { up: function(p){
      var vh = w.innerHeight;
      gal.forEach(function(f){ var z = parseFloat(f.style.getPropertyValue('--z')) || 1; f.style.setProperty('--gy', ((.5 - p) * vh * (MOB() ? .3 : .9) * z).toFixed(1)); });
    } };
  }

  /* ---------- 5 · El club ---------- */
  var CX = d.querySelector('.cx'), CC = null;
  if (CX){
    var cw = CX.querySelector('.cx-w'), cch = split(cw);
    CC = {
      fit: function(){ CX.style.setProperty('--fc', fitSize([cw], w.innerWidth * .96, w.innerHeight * (MOB() ? .5 : .4)).toFixed(1) + 'px'); },
      up: function(p){
        CX.style.setProperty('--q', ez(cl(p / .45)).toFixed(4));
        cch.forEach(function(c, i){ c.style.setProperty('--t', ez(cl((p - .08 - i * .05) / .3)).toFixed(4)); });
        CX.style.setProperty('--k2', ez(cl((p - .32) / .3)).toFixed(4));
        CX.style.setProperty('--k3', ez(cl((p - .2) / .25)).toFixed(4));
      }
    };
  }

  /* ---------- 4 · Bloque claro: las polaroids de la gira, a distinta velocidad ---------- */
  var scat = $$('.jx-scat .jx-pol');

  /* ---------- Vídeos: solo en pantalla ---------- */
  var vids = $$('video[data-mk-v]');
  vids.forEach(function(v){ var src = MOB() && v.getAttribute('data-m') ? v.getAttribute('data-m') : v.getAttribute('data-d'); if (src && !RM) v.src = src; });
  if ('IntersectionObserver' in w && !RM){
    var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ var v = e.target; if (e.isIntersecting){ var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); } else v.pause(); }); }, { rootMargin: '120px 0px' });
    vids.forEach(function(v){ vio.observe(v); });
  }

  /* ---------- Bucle ---------- */
  var tick = false;
  function prog(el){ var r = el.getBoundingClientRect(), len = el.offsetHeight - w.innerHeight; return len > 0 ? cl(-r.top / len) : (r.top < 0 ? 1 : 0); }
  function vis(el){ var r = el.getBoundingClientRect(); return r.bottom > -60 && r.top < w.innerHeight + 60; }
  function frame(){
    tick = false; if (RM) return;
    if (A && vis(A)) MO.up(Math.max(0, -A.getBoundingClientRect().top));
    if (Q && vis(Q)) QQ.up(prog(Q));
    if (CX && vis(CX)) CC.up(prog(CX));
    if (!MOB()) scat.forEach(function(pl){ var r = pl.getBoundingClientRect(); if (r.bottom < -100 || r.top > w.innerHeight + 100) return; var k = parseFloat(pl.style.getPropertyValue('--s')) || 1; pl.style.setProperty('--py', ((r.top + r.height / 2 - w.innerHeight / 2) * (k - 1) * -.35).toFixed(1)); });
  }
  function onScroll(){ if (!tick){ tick = true; w.requestAnimationFrame(frame); } }
  function layout(){
    if (H) H.fit();
    if (CC) CC.fit();
    if (RM){
      if (H){ H.b.forEach(function(c){ c.style.transform = 'none'; }); }
      if (CC) CC.up(1);
      return;
    }
    if (MO) MO.fit();
    frame();
  }
  w.addEventListener('scroll', onScroll, { passive: true });
  var rt; w.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(layout, 120); });
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(layout);
  w.addEventListener('load', layout);
  layout();
})();
